import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const OrdersDetails = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding: 0px 70px;

  & #copy-to-clipboard {
    position: absolute;
    right: 150px;
    top: -35px;
  }
`;

export const CancelBtn = styled.div`
  position: absolute;
  width: 130px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 4px;
  height: 30px;
  font: 1000 11px ${fonts.secondary};
  color: ${colors.white};
  text-align: center;
  line-height: 22px;
  text-transform: uppercase;
  border-radius: 4px;
  background: ${colors.primary};
  right: 0px;
  top: -35px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const QuestionsLeft = styled.div`
  width: 40%;
  ul {
    list-style: none;
    padding: 0px;
  }
`;

export const Question = styled.div`
  border-bottom: 1px solid ${colors.greyLighter};
  span {
    display: block;
    color: ${colors.greyDark};
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const Title = styled.span`
  font: 500 13px ${fonts.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  padding-top: 12px;
`;
export const Answer = styled.span`
  font: 300 14px ${fonts.secondary};
  padding-bottom: 17px;
`;

export const DetailsRight = styled.div`
  width: 57%;
`;

export const PhotoGrid = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
`;

export const Photo = styled.img`
  width: 125px;
  height: 125px;
  margin: 10px;
  object-fit: cover;
  cursor: pointer;
`;

export const DeleteButton = styled.img`
  height: 21px;
  width: 21px;
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
`;

export const PhotoContainer = styled.div`
  position: relative;

  p{
    text-align: center;
    font-size: 13px;
  }
`;

export const BigPicture = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: 60vh;
    max-width: 100%;
    object-fit: contain;
  }
`;

export const SpinnerContainer = styled.div`
  padding-top: 30px;
`;

export const AddText = styled.p`
  color: ${colors.primary};
  font-weight: 500;
  margin-top: 20px;
  text-transform: uppercase;
  width: fit-content;
  cursor: pointer;
`;

export const ModalPhoto = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
`;
